import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { OfferModule } from "../../blocks/OfferModule";

/**
 * toppers ProductDisplayPage ``modules`` BOTTOM body assembly.
 *
 * The ``cms/product_display_page.html`` split the ``offer`` block out of
 * the main body loop into its own ``{% include_block %}`` hydration root below
 * the rest of the modules. This island reproduces that bottom root: it renders
 * ONLY the ``offer`` block(s).
 *
 * Every NON-``offer`` key renders in the disjoint ``ProductDisplayPageBodyTemplate``
 * (the TOP island). Because thelabui ``StreamField`` THROWS on an unmapped block
 * type, we PRE-FILTER the value array to ``offer`` (order-preserving) so the
 * single-key map covers exactly the remaining members; the ``isOffer`` type
 * predicate narrows the discriminant union accordingly. Non-offer blocks are
 * dropped here (they belong to the top island), reproducing the split.
 */
type Block = NonNullable<
    Immutable<{
        page: templates.ProductDisplayPageTemplate["page"];
    }>["page"]["modules"]
>["value"][number];
type OfferBlock = Extract<Block, { type: "offer" }>;

const isOffer = (block: Block): block is OfferBlock => block.type === "offer";

export const ProductDisplayPageOffer = (
    props: Immutable<{ page: templates.ProductDisplayPageTemplate["page"] }>,
): React.JSX.Element | null => {
    const modules = props.page.modules;
    if (!modules) {
        return null;
    }
    const value = modules.value.filter(isOffer);
    return (
        <StreamField
            tagName={React.Fragment}
            value={value}
            components={{
                offer: (block) => <OfferModule value={block.value} />,
            }}
        />
    );
};
